import { FC } from "react";
import styles from "./index.module.scss";
import { Button } from "@/components/button";
import Modal from "@/components/modal";

interface ConfirmationModalProps {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel: () => void;
  visible: boolean;
  testId?: string;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  visible = true,
  testId,
}) => {
  return (
    <Modal visible={visible} title={title} onClose={onCancel} data-cy={`${testId}-modal`}>
      <p>{message}</p>
      <div className={styles.buttonRow}>
        <Button
          cta={false}
          text={cancelText}
          size="small"
          onClick={onCancel}
          data-cy={`${testId}-cancel-button`}
        />
        <Button
          text={confirmText}
          onClick={onConfirm}
          size="small"
          data-cy={`${testId}-continue-button`}
        />
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
